import React, { useEffect, useState, useContext } from "react";
import {
    collection,
    getDocs,
    addDoc,
    setDoc,
    doc,
    query,
    orderBy,
    limit,
    Timestamp
} from "firebase/firestore";
import { AuthContext } from "../../services/AuthContext";
import "./Indisponibilidades.css"; // Asegúrate de que apunte a tu archivo CSS
import logo from '../../assets/GoesGreen-300x74.png';
import logoS from "../../assets/GoesGreen-Logo-69x67.png";

import { Link, useNavigate } from 'react-router-dom';

export default function Indisponibilidades() {
    const { user, firebaseUid, db } = useContext(AuthContext);

    const [loading, setLoading] = useState(true);
    const [unavailabilities, setUnavailabilities] = useState([]); // Base de datos completa
    const [filteredData, setFilteredData] = useState([]); // Lo que se muestra realmente
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [showFilters, setShowFilters] = useState(false); // Estado para el modal de filtros
    const [equipos, setEquipos] = useState([]);
    const [origenes, setOrigenes] = useState([]);
    const [tipos, setTipos] = useState([]);
    const [showDenied, setShowDenied] = useState(false);
    const [authorizedUids, setAuthorizedUids] = useState([]);
    const [readUids, setReadUids] = useState([]);
    const [loadingAuth, setLoadingAuth] = useState(true);
    const [hasAccess, setHasAccess] = useState(false);
    const canEdit = firebaseUid && authorizedUids.includes(firebaseUid);
    const navigate = useNavigate();

    const [filter, setFilter] = useState({
        equipo: "",
        origen: "",
        tipo: "",
        fechaInicio: "",
        fechaFin: ""
    });

    // Estado del formulario con validaciones básicas
    const [formData, setFormData] = useState({
        title: "",
        detailed_code: "",
        observations: "",
        origin: "",
        start_date: "",
        end_date: "",
        type: "",
        level: ""
    });
    useEffect(() => {
        if (!db) return;

        const unsubscribe = getDocs(collection(db, "userRoles"))
            .then((snapshot) => {
                const canEdit = [];
                const canRead = [];

                snapshot.forEach((doc) => {
                    const data = doc.data();

                    if (data.canEditUnav === true) {
                        canEdit.push(doc.id);
                    }

                    if (data.canReadUnav === true) {
                        canRead.push(doc.id);
                    }
                });

                setAuthorizedUids(canEdit);
                setReadUids(canRead);
                setLoadingAuth(false);
            })
            .catch((err) => {
                console.error(err);
                setLoadingAuth(false);
            });

        return () => { };
    }, [db]);

    useEffect(() => {
        if (loadingAuth) return;
        if (!firebaseUid) return;

        const allowed =
            authorizedUids.includes(firebaseUid) ||
            readUids.includes(firebaseUid);

        if (!allowed) {
            setShowDenied(true);
            setLoading(false);

            const timer = setTimeout(() => {
                navigate("/", { replace: true });
            }, 2000);

            return () => clearTimeout(timer);
        }

        loadUnavailabilities();

    }, [
        loadingAuth,
        firebaseUid,
        authorizedUids,
        readUids,
        navigate
    ]);

    const loadUnavailabilities = async () => {
        if (!firebaseUid) return;
        try {

            setLoading(true);

            const snapshot = await getDocs(
                collection(db, "unavailabilities")
            );

            const data = snapshot.docs.map(doc => ({
                firestoreId: doc.id,
                ...doc.data()
            }));

            data.sort((a, b) =>
                (b.start_date?.toDate?.() || 0) -
                (a.start_date?.toDate?.() || 0)
            );

            setUnavailabilities(data);
            setFilteredData(data);

            setEquipos(
                [...new Set(
                    data
                        .map(x => x.detailed_code)
                        .filter(Boolean)
                )].sort()
            );

            setOrigenes(
                [...new Set(
                    data
                        .map(x => x.origin)
                        .filter(Boolean)
                )].sort()
            );

            setTipos(
                [...new Set(
                    data
                        .map(x => x.type)
                        .filter(Boolean)
                )].sort()
            );

        } catch (error) {

            console.error(error);

        } finally {

            setLoading(false);

        }
    };

    const applyFilters = () => {

        let filtered = [...unavailabilities];

        if (filter.equipo) {

            filtered = filtered.filter(
                item =>
                    item.detailed_code ===
                    filter.equipo
            );
        }

        if (filter.origen) {

            filtered = filtered.filter(
                item =>
                    item.origin ===
                    filter.origen
            );
        }

        if (filter.tipo) {

            filtered = filtered.filter(
                item =>
                    item.type ===
                    filter.tipo
            );
        }

        if (filter.fechaInicio) {

            const start =
                new Date(filter.fechaInicio);

            filtered = filtered.filter(item => {

                if (!item.start_date)
                    return false;

                return (
                    item.start_date
                        .toDate() >= start
                );
            });
        }

        if (filter.fechaFin) {

            const end =
                new Date(filter.fechaFin);

            end.setHours(
                23,
                59,
                59,
                999
            );

            filtered = filtered.filter(item => {

                if (!item.start_date)
                    return false;

                return (
                    item.start_date
                        .toDate() <= end
                );
            });
        }

        setFilteredData(filtered);

        setShowFilters(false);
    };

    const clearFilters = () => {

        setFilter({
            equipo: "",
            origen: "",
            tipo: "",
            fechaInicio: "",
            fechaFin: ""
        });

        setFilteredData(
            unavailabilities
        );

        setShowFilters(false);
    };

    const createRegistration = async (e) => {
        e.preventDefault();
        try {
            const unavailabilitiesRef = collection(db, "unavailabilities");

            const idQuery = query(unavailabilitiesRef, orderBy("id", "desc"), limit(1));
            const idSnapshot = await getDocs(idQuery);

            let lastId = 0;
            if (!idSnapshot.empty) {
                lastId = idSnapshot.docs[0].data().id || 0;
            }
            const nextId = Number(lastId) + 1;

            const generatedUuid = window.crypto?.randomUUID
                ? window.crypto.randomUUID()
                : Math.random().toString(36).substring(2) + Date.now().toString(36);

            const newDoc = {
                id: nextId,
                title: formData.title,
                detailed_code: formData.detailed_code,
                observations: formData.observations,
                origin: formData.origin,
                type: formData.type,
                level: parseFloat(formData.level),
                start_date: Timestamp.fromDate(new Date(formData.start_date)),
                end_date: Timestamp.fromDate(new Date(formData.end_date)),
                nemo: "ABEFDI01",
                ens_unit: "MWh",
                created_at: Timestamp.now(),
                importedAt: Timestamp.now(),
                uuid: generatedUuid,
                user_id: user?.uid || "5b98b458-2048-4246-b075-3978c645d2bf"
            };

            await setDoc(doc(db, "unavailabilities", String(nextId)), newDoc);

            setShowCreateModal(false);
            setFormData({
                title: "",
                detailed_code: "",
                observations: "",
                origin: "",
                start_date: "",
                end_date: "",
                type: "",
                level: ""
            });

            await loadUnavailabilities();
        } catch (error) {
            console.error("Error al guardar:", error);
            alert("Error al guardar el registro");
        }
    };

    const formatDateTime = (timestamp) => {
        if (!timestamp || !timestamp.toDate) return "Pendiente";
        const date = timestamp.toDate();
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${day}/${month}/${year} - ${hours}:${minutes} hs`;
    };

    if (showDenied) {
        return (
            <div className="App">
                <main>
                    <div style={{ color: '#cf1919', fontWeight: 600, margin: '2rem auto', textAlign: 'center', fontSize: '1.3rem' }}>No puedes acceder a este contenido</div>
                </main>
            </div>
        );
    }

    if (loading) {
        return <div className="loading-dark">Cargando indisponibilidades...</div>;
    }

    return (
        <div className="unavailabilities-page">
            {/* Cabecera estilo Goesgreen (Gris oscuro/negro con letras blancas) */}
            <div className="top-navbar">
                {/* El logo ocupa la primera columna */}
                <Link to="/">
                    <img
                        src={logo}
                        alt="GoesGreen Logo"
                        className="static-logo4 logo-full2"
                    />

                    <img
                        src={logoS}
                        alt="GoesGreen Logo"
                        className="static-logo4 logo-small2"
                    />
                </Link>

                {/* El nav-left ocupa la segunda columna (la central) */}
                <div className="nav-left">
                    <h1>{showCreateModal ? "Nuevo registro" : "Indisponibilidades"}</h1>
                </div>

                {/* Opcional: Si quieres equilibrar, puedes dejar un div vacío o 
        poner algo a la derecha para que el centro sea perfecto */}
                <div className="nav-right"></div>
            </div>
            {showCreateModal ? (
                <div className="form-fullscreen-wrapper2">
                    <form onSubmit={createRegistration} className="goesgreen-form2">

                        <div className="form-item2">
                            <label>Título</label>
                            <input
                                type="text"
                                value={formData.title}
                                onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                                required
                            />
                        </div>

                        <div className="form-item2">
                            <label>Equipo</label>
                            <select
                                value={formData.detailed_code}
                                onChange={(e) => setFormData({ ...formData, detailed_code: e.target.value })}
                                required
                            >
                                <option value="" disabled>Seleccione un equipo</option>
                                <option value="Falla interna">Falla interna</option>
                                <option value="Salida de línea">Salida de línea</option>
                                <option value="Limitación de la distribuidora">Limitación de la distribuidora</option>
                            </select>
                        </div>

                        <div className="form-item2">
                            <label>Observaciones</label>
                            <textarea
                                value={formData.observations}
                                onChange={(e) => setFormData({ ...formData, observations: e.target.value })}
                            />
                        </div>

                        <div className="form-item2">
                            <label>Origen</label>
                            <select
                                value={formData.origin}
                                onChange={(e) => setFormData({ ...formData, origin: e.target.value })}
                                required
                            >
                                <option value="" disabled>Seleccione un origen</option>
                                <option value="Interno">Interno</option>
                                <option value="Externo">Externo</option>
                            </select>
                        </div>

                        <div className="form-item2">
                            <label>Fecha y hora de inicio</label>
                            <input
                                type="datetime-local"
                                value={formData.start_date}
                                onChange={(e) => setFormData({ ...formData, start_date: e.target.value })}
                                required
                            />
                        </div>

                        <div className="form-item2">
                            <label>Fecha y hora de fin</label>
                            <input
                                type="datetime-local"
                                value={formData.end_date}
                                onChange={(e) => setFormData({ ...formData, end_date: e.target.value })}
                                required
                            />
                        </div>

                        <div className="form-item2">
                            <label>Tipo</label>
                            <select
                                value={formData.type}
                                onChange={(e) => setFormData({ ...formData, type: e.target.value })}
                                required
                            >
                                <option value="" disabled>Seleccione un tipo</option>
                                <option value="Programado">Programado</option>
                                <option value="No programado">No programado</option>
                            </select>
                        </div>

                        <div className="form-item2">
                            <label>E.N.S. (MWh)</label>
                            <input
                                type="number"
                                step="any"
                                value={formData.level}
                                onChange={(e) => setFormData({ ...formData, level: e.target.value })}
                                required
                            />
                        </div>

                        <div className="form-button-group2">
                            <button
                                type="button"
                                className="btn-goesgreen-secondary2"
                                onClick={() => setShowCreateModal(false)}
                            >
                                Cancelar
                            </button>
                            <button type="submit" className="btn-goesgreen-primary2">
                                Guardar Registro
                            </button>
                        </div>

                    </form>
                </div>
            ) : (
                /* VISTA LISTADO PRINCIPAL */
                <>
                    <div className="unavailabilities-list">
                        {filteredData.map((item) => (
                            <div key={item.firestoreId} className="unavailability-card">
                                <div className="card-title2">
                                    {item.title} - {item.detailed_code}
                                </div>

                                <div className="card-meta2">
                                    <span>{item.nemo || "ABEFDI01"}</span>
                                    <span>|</span>
                                    <span>{item.level} {item.ens_unit || "MWh"}</span>
                                    <span>|</span>
                                    <span>Inicio: {formatDateTime(item.start_date)}</span>
                                    <span>|</span>
                                    <span>Fin: {formatDateTime(item.end_date)}</span>
                                </div>

                                <div className="card-observations2">
                                    {item.observations || item.title || "Sin observaciones registradas."}
                                </div>
                            </div>
                        ))}

                        {filteredData.length === 0 && (
                            <div className="empty-state2">
                                No hay indisponibilidades registradas.
                            </div>
                        )}
                    </div>

                    {/* Botón Flotante "+" Verde Tecnológico */}
                    {canEdit && (
                        <button
                            className="add-floating-button2"
                            onClick={() => setShowCreateModal(true)}
                        >
                            +
                        </button>
                    )}
                    <button className="filter-floating-button2" onClick={() => setShowFilters(true)}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 5h18" /><path d="M6 12h12" /><path d="M10 19h4" /></svg>
                    </button>
                </>
            )}

            {/* MODAL DE FILTROS */}
            {showFilters && (


                <div className="filter-modal-overlay2" onClick={() => setShowFilters(false)}>

                    <div className="goesgreen-filter-modal2" onClick={(e) => e.stopPropagation()}>

                        <h3>Filtros</h3>

                        <div className="form-item2">

                            <label>Equipo</label>

                            <select
                                value={filter.equipo}
                                onChange={(e) =>
                                    setFilter({
                                        ...filter,
                                        equipo: e.target.value
                                    })
                                }
                            >
                                <option value="">
                                    Todos
                                </option>

                                {equipos.map(item => (

                                    <option
                                        key={item}
                                        value={item}
                                    >
                                        {item}
                                    </option>

                                ))}
                            </select>

                        </div>

                        <div className="form-item2">

                            <label>Origen</label>

                            <select
                                value={filter.origen}
                                onChange={(e) =>
                                    setFilter({
                                        ...filter,
                                        origen: e.target.value
                                    })
                                }
                            >
                                <option value="">
                                    Todos
                                </option>

                                {origenes.map(item => (

                                    <option
                                        key={item}
                                        value={item}
                                    >
                                        {item}
                                    </option>

                                ))}
                            </select>

                        </div>

                        <div className="form-item2">

                            <label>Tipo</label>

                            <select
                                value={filter.tipo}
                                onChange={(e) =>
                                    setFilter({
                                        ...filter,
                                        tipo: e.target.value
                                    })
                                }
                            >
                                <option value="">
                                    Todos
                                </option>

                                {tipos.map(item => (

                                    <option
                                        key={item}
                                        value={item}
                                    >
                                        {item}
                                    </option>

                                ))}
                            </select>

                        </div>

                        <div className="form-item2">

                            <label>Fecha inicio</label>

                            <input
                                type="date"
                                value={filter.fechaInicio}
                                onChange={(e) =>
                                    setFilter({
                                        ...filter,
                                        fechaInicio: e.target.value
                                    })
                                }
                            />

                        </div>

                        <div className="form-item2">

                            <label>Fecha fin</label>

                            <input
                                type="date"
                                value={filter.fechaFin}
                                onChange={(e) =>
                                    setFilter({
                                        ...filter,
                                        fechaFin: e.target.value
                                    })
                                }
                            />

                        </div>

                        <div className="form-button-group2">

                            <button
                                className="btn-goesgreen-secondary2"
                                onClick={clearFilters}
                            >
                                Limpiar
                            </button>

                            <button
                                className="btn-goesgreen-primary2"
                                onClick={applyFilters}
                            >
                                Filtrar
                            </button>

                        </div>

                    </div>

                </div>

            )}
        </div>
    );
}